// redux/Country/actions.js
import api from '../../config/base';
import {
  FETCH_COUNTRIES_SUCCESS,
  FETCH_COUNTRIES_FAILURE,
  FETCH_COUNTRY_SUCCESS,
  FETCH_COUNTRY_FAILURE,
  CREATE_COUNTRY_SUCCESS,
  CREATE_COUNTRY_FAILURE,
  UPDATE_COUNTRY_SUCCESS,
  UPDATE_COUNTRY_FAILURE,
  DELETE_COUNTRY_SUCCESS,
  DELETE_COUNTRY_FAILURE,
} from './types';

// Fetch all countries
export const fetchCountries = () => async (dispatch) => {
  try {
    const res = await api.get('/country');
    dispatch({
      type: FETCH_COUNTRIES_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_COUNTRIES_FAILURE,
      payload: error.message,
    });
  }
};

// Fetch a single country by ID
export const fetchCountryById = (id) => async (dispatch) => {
  try {
    const res = await api.get(`/country/${id}`);
    dispatch({
      type: FETCH_COUNTRY_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_COUNTRY_FAILURE,
      payload: error.message,
    });
  }
};

// Create a new country
export const createCountry = (country) => async (dispatch) => {
  try {
    const res = await api.post('/country', country);
    dispatch({
      type: CREATE_COUNTRY_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: CREATE_COUNTRY_FAILURE,
      payload: error.message,
    });
  }
};

// Update a country by ID
export const updateCountry = (id, country) => async (dispatch) => {
  try {
    const res = await api.put(`/country/${id}`, country);
    dispatch({
      type: UPDATE_COUNTRY_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: UPDATE_COUNTRY_FAILURE,
      payload: error.message,
    });
  }
};

// Delete a country by ID
export const deleteCountry = (id) => async (dispatch) => {
  try {
    await api.delete(`/country/${id}`);
    dispatch({
      type: DELETE_COUNTRY_SUCCESS,
      payload: id,
    });
  } catch (error) {
    dispatch({
      type: DELETE_COUNTRY_FAILURE,
      payload: error.message,
    });
  }
};
